import { ECstore } from './store';
import { emailContextValues } from 'mini-mail-bootstrap/lib/routing/mailViewHandler';

/***
 * Return true if the route matches the one of a mail module EC route and if the email has been loaded
 */
export function getHasECLoaded() {
    return (
        emailContextValues.ECPath === false ||
        (emailContextValues.ECPath === true && ECstore.isLoaded === true)
    );
}
